//Action to display and hide the loader
import { SHOW_LOADER } from "../types/loaderUtil";
export const showLoader = () => {
  return {
    type: SHOW_LOADER,
    body: true,
  };
};
export const hideLoader = () => {
  return {
    type: SHOW_LOADER,
    body: false,
  };
};
